import { render, staticRenderFns } from "./setUserInfo.vue?vue&type=template&id=477f8108&scoped=true"
import script from "./setUserInfo.vue?vue&type=script&lang=js"
export * from "./setUserInfo.vue?vue&type=script&lang=js"
import style0 from "./setUserInfo.vue?vue&type=style&index=0&id=477f8108&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477f8108",
  null
  
)

export default component.exports